module.exports = __webpack_public_path__ + "2ccb559fde3832610e96aa567ea8a8bd.pdf";